<template>
  <div class="modal-dialog" role="document">
    <form>
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="exampleModalLabel">Firma conforme: foto</h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal"><i class="icon-close-cross-link icon-btn"></i></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col dropzone">
            <canvas ref="canvas" v-bind:width="canvasWidth" v-bind:height="canvasHeight" v-on:drop="onDropOnCanvas" v-on:dragover="function(e){e.preventDefault();}"></canvas>
            <p class="no-image-message" v-if="!imageIsSelected">Arrastre imagen aquí<br>o haga clic para seleccionar.</p>
            <input class="form-control-file" type="file" name="file" id="firmaConformeUploadFile" v-on:change="onFileToUploadChange($event.target.files)">
          </div>
        </div>
        <div class="row row-buttons">
          <p class="col col-8 offset-4 accept-button text-center"><button type="button" v-bind:disabled="!imageIsSelected" class="btn btn-block btn-primary" v-on:click="uploadFile">SUBIR</button></p>
        </div>
        <div class="alert alert-warning" v-if="alertMessage">
          {{ alertMessage }}
        </div>
      </div>
    </div>
    </form>
  </div>
</template>

<style scoped>
  .dropzone {
    position: relative;
  }
  canvas {
    width: 100%;
    height: auto;
    background-color: #DDD;
  }
  input.form-control-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  p.no-image-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
</style>

<script>

import apiService from '../../services/api-service.js';

export default {
  props: [
    "ticketId",
    "modalElementId",
    "firmaConformeClienteApiUrl"
  ],
  data() {
    return {
      isThereImage: false,
      imageIsSelected: false,
      isSendingImage: false,
      alertMessage: '',
      canvasWidth: 512,
      canvasHeight: 512,
      jpgQuality: .7 // 0 to 1
    }
  },
  mounted() {
  },
  methods: {
    uploadFile() {
      this.isSendingImage = true;
      this.alertMessage = "";
      axios({
        method: 'put',
        url: this.firmaConformeClienteApiUrl,
        data: {
          dataUrl: this.$refs.canvas.toDataURL('image/jpeg', this.jpgQuality)
        }
      }).then(response => {
        if(response.data.status == apiService.STATUS_OK) {
          this.isSendingMessage = false;
          this.closeModal();
          location.reload();
        } else {
          this.isSendingMessage = false;
          this.alertMessage = "Error: " + response.data.message;
        }
      }).catch(error => {
        this.isSendingMessage = false;
        this.alertMessage = "Error de conexión";
        console.log(error);
      });
    },
    onDropOnCanvas(event) {
      event.preventDefault();
      console.log(event);
    },
    onFileToUploadChange(files) {
      this.createImage(files[0]);
    },
    closeModal() {
      $('#' + this.modalElementId).modal('hide');
    },
    createImage(file) {
      var reader = new FileReader();
      var image = new Image();
      reader.onload = (e) => {
        image.onload = (e) => {
          var canvas = this.$refs.canvas;
          var context = canvas.getContext("2d");
          if(image.naturalWidth > 0 && image.naturalHeight > 0) {
            var ratioX = this.canvasWidth / image.naturalWidth;
            var ratioY = this.canvasHeight / image.naturalHeight;
            var ratio = Math.max(ratioX, ratioY);
            var sx = (image.naturalWidth - this.canvasWidth / ratio) / 2;
            var sy = (image.naturalHeight - this.canvasHeight / ratio) / 2;
            var swidth = this.canvasWidth / ratio;
            var sheight = this.canvasHeight / ratio;
            context.drawImage(image, sx, sy, swidth, sheight, 0, 0, this.canvasWidth, this.canvasHeight);
            this.imageIsSelected = true;
          } else {
            context.drawImage(image, 0, 0, this.canvasWidth, this.canvasHeight);
          }
        }
        image.src = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function(e) {
      this.imageIsSelected = false;
      this.imageDataUrl = '';
    }
  }
}
</script>
